import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { TokenService } from '../../service/token.service';
import { GlobalService } from '../../service/global.service';
import {
  environment
} from 'src/environments/environment';
import { ProjectSaleCustomFilter, ProjectSaleInfo } from '../../model/projectsale.model';
import { CompanyInfo } from '../../model/company.model';

@Component({
  selector: 'app-lead-select',
  templateUrl: './lead-select.component.html',
  styleUrls: ['./lead-select.component.css']
})
export class LeadSelectComponent implements OnInit {

  @Output() public onSelected = new EventEmitter();
  @Input() Multiselect: boolean = false;
  @Input() Custom: string = '';

  @Input() ButtonColor: string = 'btn-blue';
  @Input() ButtonOutlineColor: string = 'blue';
  @Input() TableColor: string = 'table-stand-blue';

  selected: string;

  baseurl: string;
  _ForK2: string;
  _EmpCode: string;

  // Primary data
  modelOnPromise: Promise<ProjectSaleInfo[]>
  modelList: ProjectSaleInfo[] = [];

  //search
  txtSearchLeadCode: string;
  txtSearchLeadName: string
  txtSearchCompanyCode: string

  isSearchSubmitted: boolean = false;
  lCompany: CompanyInfo[] = [];

  //Pagination variable
  public indexNo: number = 0;
  public currentPageNumber: number
  public count: number
  public totalPages: number
  public environment: number
  public pagesize: number = 5;


  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private activatedRoute: ActivatedRoute, private TokenService: TokenService, private GlobalService: GlobalService) {
    this.baseurl = environment.base_api;

    this._ForK2 = this.activatedRoute.snapshot.params.ForK2;
    this._EmpCode = localStorage.getItem("EmpCode");
  }

  ngOnInit(): void {
    this.reset();
    this.currentPageNumber = 1;
    this.LoadData();

    this.LoadCompany().then((data) => {
      this.lCompany = data;
    });
  }


  btnClick_search() {
    this.isSearchSubmitted = true;
    this.selected = "";
    this.currentPageNumber = 1;
    this.indexNo = 0;
    this.pagesize = 5;
    this.LoadData()
  }

  btnClick_clearSearch() {
    this.reset();
    this.LoadData();
  }

  btnClick_select(param) {
    let x = this.modelList.filter(x => x.ProjectSaleCode == param);
    this.selected = param;
    this.onSelected.emit(x);
  }

  btnClick_multiselect() {
    var listselected = $('[name="checkboxMultiselect"]:checked').filter(function () {
      return !(this as HTMLInputElement).disabled
    });

    let list = [];

    for (let x = 0; x < listselected.length; x++) {
      list.push((<HTMLInputElement>listselected[x]).value);
    }

    let listres = this.modelList.filter(x => list.includes(x.ProjectSaleCode));

    this.onSelected.emit(listres);
  }

  reset() {
    this.txtSearchLeadCode = "";
    this.txtSearchLeadName = "";
    this.txtSearchCompanyCode = "";
    this.selected = "";
    this.indexNo = 0;
    this.currentPageNumber = 1;
    this.pagesize = 5;

    this.isSearchSubmitted = false;
  }

  chkallclick(traget) {
    var check = $(traget.currentTarget).is(":checked");
    $('[name="checkboxMultiselect"]').filter(function () {
      return !(this as HTMLInputElement).disabled
    }).prop('checked', check);

    this.btnClick_multiselect();
  }

  //============================ Data Loading [Start] =========================================
  LoadData() {
    this.getlist()
      .then(
        data => {
          this.modelList = data;
          //this.YearList = [...new Set(data.map(event => new Date(event.TimeSheetDate).getFullYear().toString()))];
          this.count = (this.modelList.length != 0) ? data[0].countTotal : 0;
        }
      ).then(() => {
        if (this.count == 0) {
          this.currentPageNumber = 0;
        }
        this.totalPages = Math.ceil(this.count / this.pagesize)
      })
  }

  async getlist(): Promise<ProjectSaleInfo[]> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber - 1) * this.pagesize;

      var objectjson = {};

      objectjson['ProjectSaleCode'] = this.txtSearchLeadCode;
      objectjson['ProjectSaleName'] = this.txtSearchLeadName;
      objectjson['ProjectSaleCompanyCode'] = this.txtSearchCompanyCode;

      objectjson['rowFetch'] = this.pagesize;
      objectjson['rowOFFSet'] = offset;

      if (this.Custom != null && this.Custom != "" && this.Custom == "SaleEffortEstimation") {
        let x = new ProjectSaleCustomFilter();
        x.ProjectSaleEffortEstimation = true;
        objectjson['ProjectSaleCustomFilter'] = x;
      }

      let strjson = JSON.stringify(objectjson);

      this.modelOnPromise = this.httpClient
        .post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/GetProjectSaleModal",
          strjson, httpOptions)
        .toPromise()

      return this.modelOnPromise;
    }
  }

  async LoadCompany() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      let strjson = JSON.stringify(objectjson);

      return await this.httpClient.post<CompanyInfo[]>(this.baseurl + "Company/GetCompany", strjson, httpOptions)
        .toPromise()
    }
  }

  //============================ Pagination [Start] =========================================
  LoadListPagination(traget) {
    this.currentPageNumber = traget.currentPageNumber;
    this.totalPages = traget.totalPages;
    this.indexNo = traget.index;
  }

  OnLoadListFinished(traget = null) {

    if (traget != null) { // check call function from change page or onloadfrist
      this.LoadListPagination(traget);
      this.LoadData();
    }
  }
  //============================ Pagination [End] =========================================
}
